import React  from 'react'
import Footer from '../Common/Footer'
import Header from '../Common/Header'

const About = () => {    
   return (
      <>
         <section className="tax-line">
            <div className="container">
               <p>Tax time is approaching, has your agent spoken to you about your rental income?<br />
               <a href="">Get your free rental report today.</a></p>
            </div>
         </section>

         <section className="build_property spacing">
            <div className="container">
               <div className="row">
                  <div className=" col-lg-5 col-xs-12 d-flex order-2 order-md-1">
                     <div className="content">
                        <h2>We’re driven to rebuild property management</h2>
                        <p>While helping our retired parents get their finances in order, we found they'd been paying an agent, what seemed like an obscene amount of money in fees for the past 20 years. In the meantime, their property manager had changed every few months, sometimes with no notice, and they weren't getting real value for their money. That’s when we realised, it's time for a change in property management. So, we're redefining it. Our incredible team is focused on delivering an amazing service enhanced with intuitive, easy to use technology.</p>
                     </div>
                  </div>
                  
                  <div className="col-lg-7 col-xs-12 order-1">
                     <div className="content_img">
                        <img src="/images/people.jpg" className="w-100 img-responsive" alt="people"/>
                     </div>
                  </div>
               </div>
            </div>
         </section>

         <section className="location spacing">
            <div className="container">
               <div className="row">
                  <div className="col-lg-6 col-xs-12 d-flex order-2 order-md-1">
                     <div className="content">
                        <span>locations</span>
                        <h2>Sydney, Central Coast,
                           Melbourne and Brisbane</h2>
                        <p>We have offices in Sydney, Melbourne and Brisbane. More
                           Locations coming soon.</p>
                     </div>
                  </div>
            
                  <div className="col-lg-6 col-xs-12 order-1">
                     <div className="row">
                        <div className="col-lg-6 col-6">
                           <div className="content_img">
                              <img src="/images/location1.jpg" className="w-100 img-responsive" alt="location1"/>
                           </div>
                        </div>
                        <div className="col-lg-6 col-6">
                           <div className="content_img">
                              <img src="/images/location2.jpg" className="w-100 img-responsive" alt="location2"/>
                           </div>
                        </div>
                        <div className="col-lg-6 col-6">
                           <div className="content_img">
                              <img src="/images/location3.jpg" className="w-100 img-responsive" alt="location"/>
                           </div>
                        </div>
                        <div className="col-lg-6 col-6">
                           <div className="content_img">
                              <img src="/images/location4.jpg" className="w-100 img-responsive" alt="location"/>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>

         <section className="partner spacing">
            <div className="container">
               <ul>
                  <li>Our team have worked at</li>
                  <li><img src="/images/uber.png" alt="uber"/></li>
                  <li><img src="/images/google.png" alt="google"/></li>
                  <li><img src="/images/bcg.png" alt="bcg"/></li>
                  <li><img src="/images/hooker.png" alt="hooker"/></li>
                  <li><img src="/images/mc-grath.png" alt="mc-grath"/></li>
                  <li><img src="/images/belle.png" alt="belle"/></li>
                  <li><img src="/images/ray-white.png" alt="ray-white"/></li>
               </ul>
            </div>
         </section>

         <section className="meet spacing">
            <div className="container">
               <div className="head">
                  <h2>The perfect mix of experienced property<br />
                     managers and software engineers</h2>
               </div>

               <div className="row">
                  <div className="col-lg-4 col-md-4 col-12">
                     <div className="box">
                        <img src="images/meet1.jpg" alt=""/>                                 
                        <div className="overlay">
                           <span>Ex-Chairman @ McGrath</span>
                           <p>Cass is an advisor tp Search& Settle. The former chairman of mcgrath estate Agents, her proffessional career has spanned investment banking, M&A, IPO’s, Private equity and strategic planning. Her industry sector expertise includes real estate, media, entertainment, tech and premium consumer goods.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-12">
                     <div className="box">
                        <img src="images/meet2.jpg" alt=""/>                            
                        <div className="overlay">
                           <span>Ex-Chairman @ McGrath</span>
                           <p>Cass is an advisor tp Search& Settle. The former chairman of mcgrath estate Agents, her proffessional career has spanned investment banking, M&A, IPO’s, Private equity and strategic planning. Her industry sector expertise includes real estate, media, entertainment, tech and premium consumer goods.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-12">
                     <div className="box">
                        <img src="images/meet1.jpg" alt=""/>                            
                        <div className="overlay">
                           <span>Ex-Chairman @ McGrath</span>
                           <p>Cass is an advisor tp Search& Settle. The former chairman of mcgrath estate Agents, her proffessional career has spanned investment banking, M&A, IPO’s, Private equity and strategic planning. Her industry sector expertise includes real estate, media, entertainment, tech and premium consumer goods.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-12">
                     <div className="box">
                        <img src="images/meet2.jpg" alt=""/>                                 
                        <div className="overlay">
                           <span>Ex-Chairman @ McGrath</span>
                           <p>Cass is an advisor tp Search& Settle. The former chairman of mcgrath estate Agents, her proffessional career has spanned investment banking, M&A, IPO’s, Private equity and strategic planning. Her industry sector expertise includes real estate, media, entertainment, tech and premium consumer goods.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-12">
                     <div className="box">
                        <img src="images/meet1.jpg" alt=""/>                            
                        <div className="overlay">
                           <span>Ex-Chairman @ McGrath</span>
                           <p>Cass is an advisor tp Search& Settle. The former chairman of mcgrath estate Agents, her proffessional career has spanned investment banking, M&A, IPO’s, Private equity and strategic planning. Her industry sector expertise includes real estate, media, entertainment, tech and premium consumer goods.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-12">
                     <div className="box">
                        <img src="images/meet2.jpg" alt=""/>                            
                        <div className="overlay">
                           <span>Ex-Chairman @ McGrath</span>
                           <p>Cass is an advisor tp Search& Settle. The former chairman of mcgrath estate Agents, her proffessional career has spanned investment banking, M&A, IPO’s, Private equity and strategic planning. Her industry sector expertise includes real estate, media, entertainment, tech and premium consumer goods.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>

         <section className="learn spacing">
            <div className="container">
               <div className="head">
                  <h2>Learn why we started Search&Settle</h2>
                  <p>Featured on Sky News Industry Leads</p>
               </div>
               <div className="video">
                  <iframe width="580" height="350" src="https://www.youtube.com/embed/5MgBikgcWnY" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
               </div>
            </div>
         </section>
     
         <section className="meet spacing">
            <div className="container">
               <div className="head">
                  <span>Backed by experienced Operators</span>
                  <h2>Board and Advisors</h2>
               </div>
               <div className="row">
                  <div className="col-lg-4 col-md-4 col-12">
                     <div className="box">
                        <img src="images/meet1.jpg" alt=""/>                                 
                     <div className="overlay">
                        <span>Ex-Chairman @ McGrath</span>
                        <p>Cass is an advisor tp Search& Settle. The former chairman of mcgrath estate Agents, her proffessional career has spanned investment banking, M&A, IPO’s, Private equity and strategic planning. Her industry sector expertise includes real estate, media, entertainment, tech and premium consumer goods.</p>
                     </div>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-12">
                     <div className="box">
                        <img src="images/meet2.jpg" alt=""/>                            
                        <div className="overlay">
                           <span>Ex-Chairman @ McGrath</span>
                           <p>Cass is an advisor tp Search& Settle. The former chairman of mcgrath estate Agents, her proffessional career has spanned investment banking, M&A, IPO’s, Private equity and strategic planning. Her industry sector expertise includes real estate, media, entertainment, tech and premium consumer goods.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-12">
                     <div className="box">
                        <img src="images/meet1.jpg" alt=""/>                            
                        <div className="overlay">
                           <span>Ex-Chairman @ McGrath</span>
                           <p>Cass is an advisor tp Search& Settle. The former chairman of mcgrath estate Agents, her proffessional career has spanned investment banking, M&A, IPO’s, Private equity and strategic planning. Her industry sector expertise includes real estate, media, entertainment, tech and premium consumer goods.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
         
   <section className="map spacing">
      <div className="container">         
         <div className="head">
            <h2>Our Offices</h2>
         </div>
         <div className="row">
            <div className="col-lg-4 col-12">
               <div className="box">
                  <span><img src="/images/map.jpg" alt=""/></span>
                  <h4>Sydney</h4>
                  <ul>
                     <li><b>Phone:</b> 1300 00 GRIN (4746)</li>
                     <li><b>Email:</b> hello@different.com.au</li>
                     <li><b>Address:</b><br />
                        Unit 2, 6a Liverpool St
                        Paddington
                        NSW 2021</li>
                  </ul>
               </div>
            </div>
            <div className="col-lg-4 col-12">
               <div className="box">
                  <span><img src="/images/map.jpg" alt=""/></span>
                  <h4>Melbourne</h4>
                  <ul>
                     <li><b>Phone:</b> 1300 00 GRIN (4746)</li>
                     <li><b>Email:</b> hello@different.com.au</li>
                     <li><b>Address:</b><br />
                        Unit 2, 6a Liverpool St
                        Paddington
                        NSW 2021</li>
                  </ul>
               </div>
            </div>
            <div className="col-lg-4 col-12">
               <div className="box">
                  <span><img src="/images/map.jpg" alt=""/></span>
                  <h4>Brisbane</h4>
                  <ul>
                     <li><b>Phone:</b> 1300 00 GRIN (4746)</li>
                     <li><b>Email:</b> hello@different.com.au</li>
                     <li><b>Address:</b><br />
                        Unit 2, 6a Liverpool St
                        Paddington
                        NSW 2021</li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
   </section>

   <section className="check-service spacing">
      <div className="container">
         <div className="head">
            <h2>Check if we service your area</h2>
         </div>
         <div className="col-lg-6 offset-lg-3">
            <div className="location_search">
               <input type="text" placeholder="Search by suburb or postcode"/>
               <button type="button" className="btn">check location</button>
            </div>
         </div>
      </div>
   </section>
  </>
 )   
}



export default About